<template>
	<div class="newClass">
		<el-dialog title="新建分组" :visible.sync="dialogVisible" width="50%" append-to-body>
			<el-input v-model="ipt" size="mini"></el-input>
			<el-checkbox v-model="checked" v-if="userId == 'super'">设为系统分组</el-checkbox>
			<el-button class="selectIcon" type="text" size="mini" @click="select">选择图标</el-button>
			<img v-if="tubiaoClass" :src="isIcon(tubiaoClass)" alt="" style="width: 22px;height: 22px;">
			<selectIcon ref="selectIcon" @getVal="valGet"></selectIcon>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false" size="mini">取 消</el-button>
				<el-button type="primary" @click="create" size="mini">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import selectIcon from './selectIcon'
	import { mapState } from 'vuex'
	import {
		AddTemplate,
		getNowFormatDate,
	} from "@/api/modules/basicData/task";
	export default {
		data() {
			return {
				ipt: '',
				dialogVisible: false,
				tubiaoClass: '',
				checked: false
			}
		},
		computed:{
			...mapState({
				userId: state=>state.task.userId,
				category: state => state.template.category,
				allTemplate: state => state.template.allTemplate,
				treeDataLeft: state => state.template.treeDataLeft,
			})
		},
		components:{
			selectIcon
		},
		methods: {
			isIcon(val){
				if(val){
					return require("@/assets/icon/"+val)
				}
			},
			valGet(val){
				this.tubiaoClass = val
			},
			select(){
				this.$refs.selectIcon.innerVisible = true;
			},
			create(){
				// console.log(this.treeDataLeft,'this.treeDataLeft');
				// return false
				let classIndex = this.treeDataLeft.length
				// console.log(classIndex,'索引');
				var thisTime = getNowFormatDate()
				let tempType = 2;
				let roleType = 0;
				if(this.checked){
					tempType = 4;
					roleType = 2;
				} else {
					tempType = 2;
					roleType = 0;
				}
				let ttt = this.allTemplate.find((value, index, arr) => {
					return value.NAME == this.ipt
				})
				if(ttt){
					this.$message({
						message: '重复模板名，请更改！',
						type: 'warning'
					});
					return false
				}
				AddTemplate(this.ipt, this.tubiaoClass, this.userId, thisTime, '', tempType, classIndex, '', roleType, this.category).then(res => {
					// console.log(res);
					if (res == 1) {
						this.$store.commit("getAllTemplate");
						this.ipt = '';
					}
					this.tubiaoClass = '';
				})
				this.dialogVisible = false
			}
		}
	}
</script>

<style scoped>
</style>
